import { apiClient } from './api'
import { PaymentSourceInfo } from '@/types/core'

export interface AddCardData {
  number: string
  exp_month: string
  exp_year: string
  cvv_code: string
  first_name?: string
  last_name?: string
  title?: string
  is_default?: boolean
  billing_address?: {
    address1?: string
    address2?: string
    city?: string
    state?: string
    zip?: string
    country?: string
  }
  recaptcha?: string
  recaptcha_action?: string
  recaptcha_token?: string
}

export interface UpdateCardData {
  number?: string
  exp_month?: string
  exp_year?: string
  cvv_code?: string
  is_default?: boolean
  billing_address?: {
    address1?: string
    address2?: string
    city?: string
    state?: string
    zip?: string
    country?: string
  }
  recaptcha?: string
  recaptcha_action?: string
  recaptcha_token?: string
}

const recaptchaHeaders = (token?: string): Record<string, string> => (token ? { 'X-Recaptcha-Token': token } : {})

export const paymentService = {
  async getPaymentSources(): Promise<PaymentSourceInfo[]> {
    const response = await apiClient.get<PaymentSourceInfo[]>('/payment_sources/')
    return response.data
  },

  async addCard(data: AddCardData): Promise<PaymentSourceInfo> {
    const response = await apiClient.post<PaymentSourceInfo>('/payment_sources/add_card/', data, {
      headers: recaptchaHeaders(data.recaptcha_token),
    })
    return response.data
  },

  async updateCard(cardId: number, data: UpdateCardData): Promise<PaymentSourceInfo> {
    const response = await apiClient.post<PaymentSourceInfo>(`/payment_sources/${cardId}/update_card/`, data, {
      headers: recaptchaHeaders(data.recaptcha_token),
    })
    return response.data
  },

  async deletePaymentSource(cardId: number): Promise<void> {
    await apiClient.delete(`/payment_sources/${cardId}/`)
  },

  async setDefaultPaymentSource(cardId: number): Promise<PaymentSourceInfo> {
    const response = await apiClient.post<PaymentSourceInfo>(`/payment_sources/${cardId}/set_default/`)
    return response.data
  },
}
